import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../css/AddCompetition.css';
import axios from 'axios';

const EditCompetitionForm = ({ id, onClose, onUpdated }) => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    name: '',
    venue: '',
    start_date: null,
    end_date: null,
    status: true,
    location: '',
    code: '',
    logo: null,
    odf_general: null,
    odf_sport: null,
    odf_codes: null,
  });

  const [oldLogo, setOldLogo] = useState('');

  useEffect(() => {
    fetchCompetition();
  }, []);

  const fetchCompetition = async () => {
    try {
      const res = await axios.get(`${API_URL}/ems/competitions/${id}`);
      const data = res.data;
      setFormData({
        name: data.name || '',
        venue: data.venue || '',
        start_date: data.start_date ? new Date(data.start_date) : null,
        end_date: data.end_date ? new Date(data.end_date) : null,
        status: Boolean(data.status),
        location: data.location || '',
        code: data.code || '',
        odf_general: data.odf_general || '',
        odf_sport: data.odf_sport || '',
        odf_codes: data.odf_codes || '',
      });
      setOldLogo(data.logo || '');
    } catch (err) {
      console.error('Failed to load competition details');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'status') {
      setFormData((prev) => ({ ...prev, [name]: value === 'Active' }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleDateChange = (name, date) => {
    setFormData((prev) => ({ ...prev, [name]: date }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, logo: e.target.files[0] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (key === 'logo' && value) {
        data.append('logo', value);
      } else if (value !== null && value !== undefined) {
        data.append(key, value);
      }
    });

    try {
      await axios.put(`${API_URL}/ems/competitions/${id}`, data);
      onUpdated();
      onClose();
    } catch (err) {
      console.error('Update failed', err);
      alert('Failed to update competition.');
    }
  };

  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <form onSubmit={handleSubmit} encType="multipart/form-data">

            <div className="modal-header">
              <h5 className="modal-title">Edit Competition</h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>

            <div className="add-competition modal-body">

              {/* Competition Name */}
              <div className="mb-3">
                <label className="form-label">Competition Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control text-dark"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>

              {/* Venue */}
              <div className="mb-3">
                <label className="form-label">Venue</label>
                <input
                  type="text"
                  name="venue"
                  className="form-control text-dark"
                  value={formData.venue}
                  onChange={handleChange}
                />
              </div>

              {/* Start & End Dates */}
              <div className="mb-3">
                <label className="add-competition form-label">Start Date</label>
                <DatePicker
                  selected={formData.start_date}
                  onChange={(date) => handleDateChange('start_date', date)}
                  className="add-competition form-control text-dark"
                  wrapperClassName="w-100"
                  dateFormat="dd-MMM-yyyy"
                  placeholderText="Select start date"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  onChangeRaw={(e) => e.preventDefault()}
                />
              </div>
              <div className="mb-3">
                <label className="add-competition form-label">End Date</label>
                <DatePicker
                  selected={formData.end_date}
                  onChange={(date) => handleDateChange('end_date', date)}
                  className="add-competition form-control text-dark"
                  wrapperClassName="w-100"
                  dateFormat="dd-MMM-yyyy"
                  placeholderText="Select end date"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  onChangeRaw={(e) => e.preventDefault()}
                />
              </div>

              {/* Location */}
              <div className="mb-3">
                <label className="form-label">Location</label>
                <input
                  type="text"
                  name="location"
                  className="form-control text-dark"
                  value={formData.location}
                  onChange={handleChange}
                />
              </div>

              {/* Code */}
              <div className="mb-3">
                <label className="form-label">Code</label>
                <input
                  type="text"
                  name="code"
                  className="form-control text-dark"
                  value={formData.code}
                  onChange={handleChange}
                />
              </div>

              {/* Existing Logo Preview */}
              {oldLogo && (
                <div className="mb-3">
                  <label>Current Logo</label>
                  <img
                    src={`${API_URL}/ems/${oldLogo}`}
                    alt="Current Logo"
                    style={{ maxWidth: '120px', display: 'block', marginTop: '10px' }}
                  />
                </div>
              )}

              {/* Upload New Logo */}
              <div className="mb-3">
                <label className="form-label">Upload New Logo</label>
                <input
                  type="file"
                  name="logo"
                  accept="image/*"
                  className="form-control"
                  onChange={handleFileChange}
                />
              </div>

              {/* Status */}
              <div className="mb-3">
                <label className="form-label d-block">Status</label>
                <div className="status-toggle">
                  <input
                    type="radio"
                    name="status"
                    id="editStatusActive"
                    value="Active"
                    checked={formData.status === true}
                    onChange={handleChange}
                  />
                  <label htmlFor="editStatusActive">Active</label>
                  <input
                    type="radio"
                    name="status"
                    id="editStatusInactive"
                    value="Inactive"
                    checked={formData.status === false}
                    onChange={handleChange}
                  />
                  <label htmlFor="editStatusInactive">Inactive</label>
                </div>
              </div>

            </div>

            <div className="modal-footer">
              <button
                type="submit"
                className="btn"
                style={{ backgroundColor: '#d9a128ba', color: '#fff', border: 'none', fontWeight: 'bold' }}
              >
                Update
              </button>
              <button
                type="button"
                className="btn"
                onClick={onClose}
                style={{ backgroundColor: '#000', color: 'white', border: 'none', fontWeight: 'bold' }}
              >
                Cancel
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default EditCompetitionForm;
